// @ngInject
function deliveryDocumentDownloadDialogService($uibModal, OrdersApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog(orderId) {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'deliveryDocumentDownloadDialogServiceController as vm',
            templateUrl: 'services/dialogs/deliveryDocumentDownloadDialog/deliveryDocumentDownloadDialog.tpl.html',
            size: 'md'
        };

        modalDefaults.resolve = {
            orderId: function() {
                return orderId;
            }
        };
        

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function deliveryDocumentDownloadDialogServiceController($uibModalInstance, $scope, orderId, OrdersApiService, ToasterService, loadSpinnerService) {
    var vm = this;

    vm.deliveryDate = {};
    vm.deliveryTimeProximity = 10;
    vm.deliveryTimeType = '1';
    vm.deliveryTimeOptions = [
        {value: '0', name:'sec'},
        {value: '1', name:'min'},
        {value: '2', name:'hr'},
        {value: '3', name:'day'}
    ];
    vm.useOriginalPrice = false;

    vm.closeModal = closeModal;
    vm.downloadDocument = downloadDocument;
    vm.flipUseOriginalPrice = flipUseOriginalPrice;
    vm.isFetchingData = false;

    activate();

    function activate() {
        loadDateSelections();


        $scope.$watch(function() { return vm.deliveryTimeType; }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                loadDateSelections();
            }
        });
        $scope.$watch(function() { return vm.deliveryTimeProximity; }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                loadDateSelections();
            }
        });
    }

    function loadDateSelections() {
        vm.isFetchingData = true;
        OrdersApiService.getWholeDeliveryDates(orderId, vm.deliveryTimeProximity, vm.deliveryTimeType).then(function(response) {
            vm.deliveryDate = {};
            // modify the date format
            response.data.deliveryDates.forEach(function(entry) {
                var dateObj = new Date(entry.startDate);

                entry.id = entry.startDate;
                //entry.description = getDeliveryDateString(dateObj);
            });
            vm.deliveryDates = response.data.deliveryDates;
            vm.orderId = orderId;
        }, function(error) {
            ToasterService.ShowError(error);
        }).finally(function() {
            vm.isFetchingData = false;
        });
    }

    function getDeliveryDateString(date) {
        if (!date) { return ''; }

        var dateStr = date.getFullYear() + '-' + zeroFill(date.getMonth() + 1, 2) + '-' + zeroFill(date.getDate(), 2) + ' ' + zeroFill(date.getHours(), 2) + ':' + zeroFill(date.getMinutes(), 2);
        if (date.getHours() === 0 && date.getMinutes() === 0) {
            dateStr = date.getFullYear() + '-' + zeroFill(date.getMonth() + 1, 2) + '-' + zeroFill(date.getDate(), 2);
        }

        return dateStr;
    }

    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            return new Array(width + ((/\./).test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }

    function closeModal(isCompleted) {
        $uibModalInstance.close(isCompleted);
    }

    function flipUseOriginalPrice(){
        vm.useOriginalPrice = !vm.useOriginalPrice;
    }

    function downloadDocument() {
        vm.isFetchingData = true;
        OrdersApiService.downloadDeliveryDocument(orderId, vm.deliveryDate.startDate, vm.deliveryDate.endDate, vm.useOriginalPrice).then(function() {
        }, function(error) {
            ToasterService.ShowError(error);
        }).finally(function() {
            closeModal(true);
        });;
    }
}

angular
    .module('services.dialogs.deliveryDocumentDownloadDialog', [])
    .service('deliveryDocumentDownloadDialogService', deliveryDocumentDownloadDialogService)
    .controller('deliveryDocumentDownloadDialogServiceController', deliveryDocumentDownloadDialogServiceController);
